module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp3_5012.8fc1c698.png";